import React, { useContext } from 'react';
import { get } from 'lodash';
import qs from 'query-string';
import styled from '@emotion/styled';

import { assetUrl } from '~/helpers';
import colours from '~/utils/colours';
import Compact from '~/App/Components/Popovers/Compact';
import { TodoCreateMode } from '~/App/Modules/TodoList/Modals/TodoCreate';
import WorkspaceContext from '~/App/Contexts/WorkspaceContext';

type ChildProps = {
  togglePopover: () => void;
};

type ItemAttr = {
  key: string;
  href: string;
  children: React.ReactNode;
};

export interface AddProps {
  children: (prop: ChildProps) => React.ReactChild;
  align?: string;
  place?: string;
}

const ItemGroup = styled.div`
  width: 210px;
  height: 257px;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(191, 191, 191, 0.5);
  background-color: white;
`;

const Item = styled.div`
  display: block;
  padding-left: 19px;
  height: 25%;
  line-height: 64.25px;
  font-family: Lato;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.16px;
  color: ${colours.textDark};

  &:hover,
  &:focus {
    cursor: pointer;
    text-decoration: none !important;
    color: ${colours.blue} !important;
    background-color: ${colours.greyLightAlt};
  }

  & > span {
    position: absolute;
    left: 60px;
    text-align: center;
  }
`;

function PopoverBody() {
  const workspaceContext = useContext(WorkspaceContext);

  const items: ItemAttr[] = [
    {
      key: 'todo',
      href: `#/todo/create?${qs.stringify({ mode: TodoCreateMode.SINGLE })}`,
      children: (
        <>
          <img
            className='menuItemIcon'
            src={assetUrl('assets/images/popover/AddAPerson.svg')}
          />
          <span>Add a person</span>
        </>
      ),
    },
    {
      key: 'group',
      href: `#/todo/create?${qs.stringify({ mode: TodoCreateMode.GROUP })}`,
      children: (
        <>
          <img src={assetUrl('assets/images/popover/AddAGroup.svg')} />
          <span>Add a group</span>
        </>
      ),
    },
    {
      key: 'csv',
      href: `/contacts/csv?${qs.stringify({
        campaign: get(workspaceContext, 'selectedWorkspace.uuid'),
      })}`,
      children: (
        <>
          <img src={assetUrl('assets/images/popover/CSV.svg')} />
          <span>Upload CSV</span>
        </>
      ),
    },
    {
      key: 'automation',
      href: '/automation',
      children: (
        <>
          <img src={assetUrl('assets/images/popover/ConnectAFunnel.svg')} />
          <span>Connect an integration</span>
        </>
      ),
    },
  ];

  return (
    <>
      <ItemGroup>
        {items.map((item) => (
          <Item {...item} as='a' key={item.key} />
        ))}
      </ItemGroup>
    </>
  );
}

export default function Add({
  children,
  align = 'left',
  place = 'below',
}: AddProps) {
  return (
    <Compact
      popoverBody={PopoverBody}
      enterExitTransitionDurationMs={250}
      align={align}
      place={place}
    >
      {children}
    </Compact>
  );
}
